import { activeCurrencySymbol } from "../../../utils/currency";
export type DatePreset = "today" | "this_week" | "this_month" | "custom";

export interface ReportFilters {
  datePreset: DatePreset;
  startDate: string;
  endDate: string;
  orderSource: "all" | "online" | "kiosk" | "counter";
  orderType: "all" | "delivery" | "pickup" | "dine_in" | "takeaway";
  restaurantId: string;
}

const toIsoDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const startOfWeek = (date: Date) => {
  const cloned = new Date(date);
  const day = cloned.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  cloned.setDate(cloned.getDate() + diff);
  cloned.setHours(0, 0, 0, 0);
  return cloned;
};

export const getRangeByPreset = (preset: DatePreset) => {
  const now = new Date();
  const today = toIsoDate(now);

  if (preset === "today") {
    return { startDate: today, endDate: today };
  }

  if (preset === "this_week") {
    return {
      startDate: toIsoDate(startOfWeek(now)),
      endDate: today,
    };
  }

  if (preset === "this_month") {
    return {
      startDate: toIsoDate(new Date(now.getFullYear(), now.getMonth(), 1)),
      endDate: today,
    };
  }

  return {
    startDate: today,
    endDate: today,
  };
};

export const buildDefaultFilters = (): ReportFilters => {
  const range = getRangeByPreset("this_month");
  return {
    datePreset: "this_month",
    startDate: range.startDate,
    endDate: range.endDate,
    orderSource: "all",
    orderType: "all",
    restaurantId: "all",
  };
};

export const buildReportParams = (filters: ReportFilters) => ({
  startDate: filters.startDate,
  endDate: filters.endDate,
  orderSource: filters.orderSource,
  orderType: filters.orderType,
  restaurantId: filters.restaurantId !== "all" ? filters.restaurantId : undefined,
});

export const currency = (value: number) => `${activeCurrencySymbol()}${value.toFixed(2)}`;
